import { render } from "./Widget_Power.vue?vue&type=template&id=5fd5f7ea"
const script = {}

import exportComponent from "C:\\Develop\\Czone_UI_EIC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__